export default __webpack_public_path__ + "static/media/img_fee_100.4166b2db.svg";